import { createAction, props } from '@ngrx/store';
import { CategoryTreeEntity } from './category-tree.models';

export const initCategoryTree = createAction('[CategoryTree Sub-header] Init');

export const loadCategoryTreeSuccess = createAction(
  '[CategoryTree/API] Load CategoryTree Success',
  props<{ categories: CategoryTreeEntity[] }>()
);

export const loadCategoryTreeFailure = createAction(
  '[CategoryTree/API] Load CategoryTree Failure',
  props<{ error: any }>()
);
